import Breadcrumb from "../../../components/breadcrumbs/Breadcrumb.vue";
import SecaoForm from "../../../components/forms/SecaoForm.vue";
import { SecaoService } from "../../../services/SecaoService";

export default {
  name: "EditarSecao",
  components: {
    Breadcrumb,
    SecaoForm
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "Página Inicial",
          disabled: false,
          href: "/"
        },
        {
          text: "Gerenciamento de Seções",
          disabled: false,
          href: "/gerenciar-secoes"
        },
        {
          text: "Editar Seção",
          disabled: true,
          href: `/secoes/editar/${this.$route.params.id}`
        }
      ],
      secaoData: {},
      secaoId: null
    };
  },
  created() {
    this.secaoId = this.$route.params.id;
    this.carregarSecao();
  },
  methods: {
    async carregarSecao() {
      try {
        const response = await SecaoService.show(this.secaoId);
        
        if (response && response.data) {
          this.secaoData = {
            id: response.data.id,
            codigo_secao: response.data.codigo_secao,
            descricao: response.data.descricao,
            ativo: response.data.ativo
          };
        } else {
          console.error('Não foi possível carregar os dados da seção.');
          this.$router.push('/gerenciar-secoes');
        }
      } catch (error) {
        console.error('Ocorreu um erro ao carregar os dados da seção:', error);
        this.$router.push('/gerenciar-secoes');
      }
    },
    async handleSave(formData) {
      try {
        // Criar FormData seguindo o padrão existente
        const postData = new FormData();
        
        postData.append("codigo_secao", formData.codigoSecao);
        postData.append("descricao", formData.descricao);
        postData.append("ativo", formData.ativo ? 1 : 0);
        
        const response = await SecaoService.update(this.secaoId, postData);
        
        if (response) {
          // Redirecionar para a lista de seções após salvar
          this.$router.push('/gerenciar-secoes');
        } else {
          throw new Error('Erro ao atualizar seção');
        }
      } catch (error) {
        console.error('Erro ao atualizar seção:', error);
        // O componente SecaoForm já trata a exibição de mensagens de erro
        throw error;
      }
    },
    handleCancel() {
      // Retornar para a tela principal do menu
      this.$router.push('/gerenciar-secoes');
    }
  }
};
